function pitchStatusIndex($translate) {
  const statuses = {};

  statuses.pitched = {
    id: 'pitched',
    name: $translate.instant('PITCHED'),
    icon: 'fa-flag'
  };

  statuses['not watching'] = {
    id: 'not watching',
    name: $translate.instant('NOT_WATCHING'),
    icon: 'fa-eye-slash'
  };

  statuses.watching = {
    id: 'watching',
    name: $translate.instant('WATCHING'),
    icon: 'fa-eye'
  };

  statuses.saving = {
    id: 'saving',
    name: $translate.instant('SAVING'),
    icon: 'fa-thumb-tack'
  };

  statuses.used = {
    id: 'used',
    name: $translate.instant('USED'),
    icon: 'fa-check-circle'
  };

  statuses.withdrawn = {
    id: 'withdrawn',
    name: $translate.instant('WITHDRAWN'),
    icon: 'fa-flag-o'
  };

  statuses.platformStatuses = [
    statuses.pitched,
    statuses['not watching'],
    statuses.watching,
    statuses.saving,
    statuses.used,
    statuses.withdrawn
  ];

  statuses.booked = {
    id: 'booked',
    name: $translate.instant('BOOKED'),
    icon: 'fa-thumbs-o-up'
  };

  statuses.declined = {
    id: 'declined',
    name: $translate.instant('DECLINED'),
    icon: 'fa-thumbs-down'
  };

  statuses.publicationStatuses = [
    statuses.pitched,
    statuses.booked,
    statuses.declined
  ];

  this.getListCopy = type => angular.copy(statuses[type]);

  this.getStatusName = name => statuses[name].name;

  this.platformStatusNamesList = (() => statuses.platformStatuses.map(obj => obj.id))();

  this.publicationStatusNamesList = (() => statuses.publicationStatuses.map(obj => obj.id))();
}

const serviceArray = [
  '$translate',
  pitchStatusIndex
];

module.exports = (ngModule) => {
  ngModule.service('pitchStatusIndex', serviceArray);
};
